import { render, staticRenderFns } from "./Uniplus.vue?vue&type=template&id=370de1eb&"
import script from "./Uniplus.vue?vue&type=script&lang=js&"
export * from "./Uniplus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports